import axios from "axios";

const token = localStorage.getItem("wow-delivery-kw-merchant-token");

const POST = async (endpoint, data, options = {}) => {
  const response = await axios.post(endpoint, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
    responseType: options.responseType || "json",
  });
  return response;
};

export default POST;
